export default __webpack_public_path__ + "static/media/placeholder_store04-it-mobile.31f457cc.png";